import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { checkLoginStatusService } from '@/services/authService.js';
import { clearUserProfile, getUserProfileThunk } from '@/store/modules/globalSlice.js';

export const checkLoginStatus = createAsyncThunk(
  'auth/checkLoginStatus',
  async (_, { dispatch }) => {
    const response = await checkLoginStatusService();

    if (!response?.loggedIn) {
      dispatch(clearUserProfile());
      return { loggedIn: false };
    }

    try {
      await dispatch(getUserProfileThunk()).unwrap();
      return response;
    } catch (error) {
      dispatch(clearUserProfile());
      return { loggedIn: false };
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isLoggedIn: false,
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(checkLoginStatus.fulfilled, (state, action) => {
      if (action && action.payload) {
        state.isLoggedIn = action.payload.loggedIn;
      } else {
        state.isLoggedIn = false;
      }
    });
  },
});

export default authSlice.reducer;
